<template>
  <CRow>
    <CCol md="6">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-grid" />Mata Pelajaran
          <div class="card-header-actions">
            <CLink href="#" class="card-header-action btn-setting">
              <a @click="addStudyProgram">
                <CIcon name="cil-plus" />
              </a>
            </CLink>
          </div>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Mata Pelajaran</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in data.data" :key="k">
                <td>
                  <table-number
                    :page="paginate.page"
                    :size="paginate.size"
                    :index="k"
                  />
                </td>
                <td>
                  {{ d.name }}
                  <CBadge color="danger" v-show="d.deleted_at">Deleted</CBadge>
                </td>
                <td class="action">
                  <btn-edit @click="doEdit(d.slug)" />
                  <btn-delete @click="doDelete(d.id)" v-show="!d.deleted_at" />
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
        <CCardFooter>
          <content-pagination
            :page="paginate.page"
            :total="paginate.total"
            :size="paginate.size"
            @input="getList"
          />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from "../../lib/helpers";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination";
export default {
  components: {
    BtnEdit,
    BtnDelete,
    TableNumber,
    ContentPagination,
  },
  data() {
    return {
      data: {},
      paginate: {},
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      HTTPAUTH.get(`/api/v1/admin/subject?size=10&page=${page}`).then((res) => {
        this.data = res.data;
        this.paginate = this.data.paginate;
      });
    },
    addStudyProgram() {
      this.$router.push({ path: "/master/subjects/new" }).catch((eres) => {});
    },
    doEdit(slug) {
      this.$router
        .push({ path: "/master/subjects/" + slug })
        .catch((eres) => {});
    },
    doDelete(id) {
      HTTPAUTH.delete(`/api/v1/admin/subject/${id}`)
        .then((res) => {
          this.getList(1);
        })
        .catch((eres) => {
          console.log(showErrorMessage(eres));
        });
    },
  },
};
</script>